<template>
    <section class="bobbleheads" ref="card">
        <slot></slot>
    </section>
</template>
<script setup>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onMounted, ref } from 'vue';

gsap.registerPlugin(ScrollTrigger);

const card = ref(null);
const frameCount = 77;
const images = [];
const punch = {
    frame:0
};
const currentFrame = index => (
    `/videos/${(index + 1).toString().padStart(4, '0')}.webp`
);
let loaded = 0;

let canvas = null;
let context = null;

const renderFrame = () => {
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(images[punch.frame], 0, 0);
}

const setupTimeline = () => {
    let tl = new gsap.timeline({
        defaults: { duration: 6 },
        scrollTrigger:{
            trigger:card.value.querySelector('.video-wrap'),
            start:'top top',
            end(){
                return '+=' + (window.outerHeight * 3);
            },
            pin:true,
            scrub:0.5
        }
    });

    tl.to(punch, {
        frame: frameCount - 1,
        snap:'frame',
        ease:'none',
        onUpdate:renderFrame
    });
    tl.to(card.value.querySelector('.screen.one'), {
        y:0,
        duration:0.5
    }, 0).to(card.value.querySelector('.bg.one'), {
        scale:1,
        duration:0.5
    }, 0).to(card.value.querySelector('.screen.one'), {
        y:'-100%',
        duration:0.5
    }, 1.7).to(card.value.querySelector('.bg.one'), {
        scale:0,
        duration:0.5
    }, 1.7).to(card.value.querySelector('.screen.two'), {
        y:0,
        duration:0.5
    }, 2).to(card.value.querySelector('.bg.two'), {
        scale:1,
        duration:0.5
    }, 2).to(card.value.querySelector('.screen.two'), {
        y:'-100%',
        duration:0.5
    }, 3.7).to(card.value.querySelector('.bg.two'), {
        scale:0,
        duration:0.5
    }, 3.7).to(card.value.querySelector('.screen.three'), {
        y:0,
        duration:0.5
    }, 4).to(card.value.querySelector('.bg.three'), {
        scale:1,
        duration:0.5
    }, 4);

    renderFrame();
}

onMounted(async () => {
    canvas = card.value.querySelector('canvas');
    context = canvas.getContext('2d');

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
    }

    setupTimeline();

    images[0].onload = renderFrame;

})
</script>
